import React from 'react';
import { TextInput } from '@gravity-ui/uikit';
import { Magnifier } from '@gravity-ui/icons';
import styles from './EntitySearch.module.scss';

interface EntitySearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  placeholder: string;
}

export const EntitySearch: React.FC<EntitySearchProps> = ({ searchQuery, setSearchQuery, placeholder }) => {
  return (
    <div className={styles.filterContainer}>
      <TextInput
        placeholder={placeholder}
        view={'normal'}
        size="m"
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value);
        }}
        className={styles.searchInput}
        startContent={
          <div className={styles.searchInputIcon}>
            <Magnifier />
          </div>
        }
      />
    </div>
  );
}; 